import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { makeRequest } from '../../api/api';

export const onboardVessel = createAsyncThunk(
  "onboarding/onboardVessel",
  async (vesselData, { rejectWithValue }) => {
    try {
      const payload = {
        ...vesselData,
        verified_emission_statement_file: undefined,  // File will be added separately
      };

      const formData = new FormData();

      for (const key in payload) {
        if (key === 'pic' && typeof payload[key] === 'object') {
          for (const picKey in payload[key]) {
            formData.append(`pic__${picKey}`, payload[key][picKey]);
          }
        } else if (payload[key] !== undefined) {
          formData.append(key, payload[key]);
        }
      }

      // Append file to formData if present
      if (vesselData.verified_emission_statement_file) {
        formData.append(
          "verified_emission_statement_file",
          vesselData.verified_emission_statement_file,
        );
      }

      const response = await makeRequest("post", "v2/pooling/onboard_pool_vessels/", formData);
      return response.data;

    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const updateOnboardVessel = createAsyncThunk(
  "onboarding/updateOnboardVessel",
  async (vesselData, { rejectWithValue }) => {
    try {
      const payload = {
        ...vesselData,
        verified_emission_statement_file: undefined,  // File will be added separately
      };

      const formData = new FormData();

      // Flatten and append payload to formData
      for (const key in payload) {
        if (key === 'pic' && typeof payload[key] === 'object') {
          // If 'pic' is an object, flatten and append each key as pic__key
          for (const picKey in payload[key]) {
            formData.append(`pic__${picKey}`, payload[key][picKey]);
          }
        } else if (payload[key] !== undefined) {
          // Append other fields directly
          formData.append(key, payload[key]);
        }
      }

      // Append file to formData if present
      if (vesselData.verified_emission_statement_file) {
        formData.append(
          "verified_emission_statement_file",
          vesselData.verified_emission_statement_file,
        );
      }

      const response = await makeRequest("post", "v2/pooling/update_onboarded_vessel/", formData);
      return response.data;

    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);




// Create the slice
const onboardingSlice = createSlice({
  name: "onboarding",
  initialState: {
    onboardedVessel: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(onboardVessel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(onboardVessel.fulfilled, (state, action) => {
        state.loading = false;
        state.onboardedVessel = action.payload;
      })
      .addCase(onboardVessel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateOnboardVessel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOnboardVessel.fulfilled, (state, action) => {
        state.loading = false;
        state.onboardedVessel = action.payload;
      })
      .addCase(updateOnboardVessel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default onboardingSlice.reducer;
